import Config from '@/config'
import request from '@/utils/request'

const uploadCreativeFile = (data) => {
  return request({
    path: `/v1/creative`,
    method: 'POST',
    data,
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const createCampaign = (data) => {
  return request(
    {
      path: `/v1/campaign`,
      method: 'POST',
      data,
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    },
    {
      options: {
        hideMessage: true,
      },
    }
  )
}

const getCampaign = (campaignId, disableCamelizeRes = false) => {
  return request(
    {
      path: `/v1/campaign/${campaignId}`,
      method: 'GET',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    },
    {
      options: {
        disableCamelizeRes,
      },
    }
  )
}

const updateCampaign = ({ campaignId, data }) => {
  return request(
    {
      path: `/v1/campaign/${campaignId}`,
      method: 'PUT',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
      data,
    },
    {
      options: {
        hideMessage: true,
        disableErrorRedirect: true,
      },
    }
  )
}

const submitPayment = ({
  cardToken,
  amount,
  billingAccountId,
  paymentMethod,
  checkoutPublicKey,
}) => {
  return request({
    path: '/v1/payment/checkout/submit',
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      card_token: cardToken,
      billing_account_id: billingAccountId,
      amount,
      payment_method: paymentMethod,
      checkout_public_key: checkoutPublicKey,
    },
  })
}

const getPaymentStatus = (paymentId) => {
  return request({
    path: `/v1/payment/${paymentId}`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const createAdvertiser = () => {
  return request({
    path: '/v1/advertiser',
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getAdvertiser = () => {
  return request(
    {
      path: '/v1/advertiser',
      method: 'GET',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    },
    {
      options: {
        hideMessage: true,
      },
    }
  )
}

const getWalletBalance = () => {
  return request({
    path: '/v1/wallet',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getWalletHistory = ({ page, pageSize }) => {
  return request({
    path: '/v1/wallet/history',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      page,
      pageSize,
    },
  })
}

const getCampaigns = ({
  statusGroup = '',
  status = '',
  page = 1,
  pageSize = 10,
}) => {
  return request({
    path: '/v1/campaign',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      page,
      pageSize,
      statusGroup,
      status,
      includeStats: true,
    },
  })
}

const deleteCampaign = (campaignId) => {
  return request({
    path: `/v1/campaign/${campaignId}`,
    method: 'DELETE',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const activateCampaign = (campaignId) => {
  return request({
    path: `/v1/campaign/${campaignId}/activate`,
    method: 'PUT',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const deactivateCampaign = (campaignId) => {
  return request({
    path: `/v1/campaign/${campaignId}/deactivate`,
    method: 'PUT',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getAdvertiserReport = ({ startDate, endDate }) => {
  return request(
    {
      path: '/v1/advertiser/reports',
      method: 'GET',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
      data: {
        startDate,
        endDate,
      },
    },
    {
      options: {
        disableCamelizeRes: true,
      },
    }
  )
}

const getAddresses = () => {
  return request(
    {
      path: '/v1/advertiser/addresses',
      method: 'GET',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    },
    {
      options: {
        hideMessage: true,
      },
    }
  )
}

const getWalletHealth = () => {
  return request({
    path: '/v1/wallet/health',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getAdtechFeatureFlag = () => {
  if (!Config.isEnabledAdtechAds) {
    return false
  }

  return request(
    {
      path: '/v1/featureflag',
      method: 'GET',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    },
    {
      options: {
        hideMessage: true,
      },
    }
  )
    .then((res) => res.data.data)
    .catch(() => ({ isAdtechEnabled: false, isAdsTopUpBannerEnabled: false }))
}

const getCPCRecommendation = (data) => {
  return request({
    path: `/v1/recommendation/cpc?${data}`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getSegment = (campaignId) => {
  return request({
    path: `/v1/segment`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getAdsAsset = ({ placementId, page, pageSize }) => {
  return request({
    path: `/v1/ad-assets`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      placementId,
      page,
      pageSize,
    },
  })
}

const getLatestRating = ({ email, feature, reCaptchaToken }) => {
  return request(
    {
      path: '/merchants/rating/latest',
      method: 'GET',
      data: {
        email,
        feature,
      },
    },
    {
      options: {
        headers: {
          'x-tamara-token': reCaptchaToken,
        },
        hideMessage: true,
      },
    }
  )
}

const saveRating = ({ rating, comment, feature, reCaptchaToken }) => {
  return request(
    {
      path: '/merchants/rating/submit',
      method: 'POST',
      data: {
        source: 'web',
        rating,
        comment,
        feature,
      },
    },
    {
      options: {
        headers: {
          'x-tamara-token': reCaptchaToken,
        },
      },
    }
  )
}

const getCampaignStatusGroup = () => {
  return request({
    path: `/v1/campaign/count-by-status-group`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getCampaignStats = ({ campaignId, startDate, endDate }) => {
  return request(
    {
      path: `v1/campaign/${campaignId}/reports`,
      method: 'GET',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
      data: {
        startDate,
        endDate,
      },
    },
    {
      options: {
        disableCamelizeRes: true,
      },
    }
  )
}

const createCampaignAudienceInsights = ({
  campaignId,
  startDate,
  endDate,
  sortBy,
}) => {
  return request({
    path: `/v1/campaign/${campaignId}/audience`,
    method: 'POST',
    data: {
      start_date: startDate,
      end_date: endDate,
      sort_by: sortBy,
      group: 'age_group,gender,country,segment,placement',
    },
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const submitAcceptTermAndCondition = () => {
  return request(
    {
      path: `/v1/advertiser/tnc`,
      method: 'POST',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    },
    {
      options: {
        hideMessage: true,
      },
    }
  )
}

const getPostpaidUsage = ({ month, year }) => {
  return request({
    path: '/v1/postpaid/usages',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      month,
      year,
    },
  })
}

const submitPostpaidBillingAccount = ({ billingAccountId }) => {
  return request({
    path: `/v1/postpaid/billing-account`,
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      billing_account_id: billingAccountId,
    },
  })
}

const getAdCredit = () => {
  return request({
    path: '/v1/ad-credit',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getAdCreditHistory = ({
  page = 1,
  pageSize = 10,
  paymentMethods,
  fromDate,
  toDate,
}) => {
  const payload = {
    page,
    pageSize,
    payment_methods: paymentMethods,
  }

  if (fromDate && toDate) {
    payload.from_date = fromDate
    payload.to_date = toDate
  }

  return request(
    {
      path: '/v1/ad-credit/history',
      method: 'GET',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
      data: payload,
    },
    {
      // Override default behavior when axios parse array field
      // due to the API required array field to be repeated without bracket
      // Default behavior: test[]=1&test[]=2
      // After bellow serializer: test=1&test=2
      paramsSerializer: (params) => {
        const searchParams = new URLSearchParams()

        for (const key in params) {
          if (!Array.isArray(params[key])) {
            searchParams.append(key, params[key])
            continue
          }

          for (const item of params[key]) {
            searchParams.append(key, item)
          }
        }

        return searchParams.toString()
      },
    }
  )
}

const submitActivatePostpaid = () => {
  return request(
    {
      path: '/v1/postpaid/activate',
      method: 'POST',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    },
    {
      options: {
        hideMessage: true,
      },
    }
  )
}

const submitDeactivatePostpaid = () => {
  return request({
    path: '/v1/postpaid/deactivate',
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPostpaidInvoices = ({ status = '', page = 1, pageSize = 10 }) => {
  return request({
    path: '/v1/postpaid/invoices',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      page,
      pageSize,
      status,
    },
  })
}

const getPostpaidInvoice = ({ invoiceId }) => {
  return request({
    path: `/v1/postpaid/invoices/${invoiceId}`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getInvoiceLink = ({ invoiceId }) => {
  return request({
    path: `/v1/postpaid/invoices/${invoiceId}/link`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const submitPostpaidPayment = ({
  cardToken,
  paymentMethod,
  checkoutPublicKey,
  invoiceId,
}) => {
  return request({
    path: `/v1/postpaid/invoices/${invoiceId}/card-payments`,
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      checkout_token: cardToken,
      checkout_public_key: checkoutPublicKey,
      payment_method: paymentMethod,
      success_url: `${window.location.origin}/#/ads/postpaid/success`,
      failure_url: `${window.location.origin}/#/ads/postpaid/failure`,
    },
  })
}

const syncPostpaidPayment = ({ invoiceId, paymentId }) => {
  return request({
    path: `/v1/postpaid/invoices/${invoiceId}/card-payments/${paymentId}/sync`,
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getPostpaidInvoiceStats = () => {
  return request(
    {
      path: '/v1/postpaid/invoices/stats',
      method: 'GET',
      customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    },
    {
      options: {
        disableCamelizeRes: true,
      },
    }
  )
}

const getAdsCreditHealth = () => {
  return request({
    path: `/v1/ad-credit/health`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getActivityLogs = ({
  actionGroup,
  action,
  fromDate,
  toDate,
  page,
  pageSize,
}) => {
  return request({
    path: '/v1/activities',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      action_group: actionGroup,
      action,
      from_date: fromDate,
      to_date: toDate,
      page,
      pageSize,
    },
  })
}

const getActivityEnums = () => {
  return request({
    path: '/v1/activities/enums',
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getConversionOrders = ({
  startDate,
  endDate,
  segmentIds,
  placementTypes,
  campaignId,
  page = 1,
  pageSize = 10,
}) => {
  return request({
    path: `/v1/campaign/${campaignId}/orders`,
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      conversion_start_date: startDate,
      conversion_end_date: endDate,
      group_segment_ids: segmentIds,
      placement_types: placementTypes,
      page,
      pageSize,
    },
  })
}

const getAudienceInsightsGroup = ({ campaignId }) => {
  return request({
    path: `/v1/campaign/${campaignId}/insight_groups`,
    method: 'GET',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
  })
}

const getOrderStats = ({ campaignId, startDate, endDate, segmentId }) => {
  return request({
    path: `/v1/campaign/${campaignId}/order-stats`,
    method: 'POST',
    customBaseURL: process.env.VUE_APP_ADTECH_BASE_URL,
    data: {
      start_date: startDate,
      end_date: endDate,
      segment_id: segmentId,
    },
  })
}

export {
  uploadCreativeFile,
  createCampaign,
  getCampaign,
  updateCampaign,
  submitPayment,
  getPaymentStatus,
  createAdvertiser,
  getAdvertiser,
  getWalletBalance,
  getWalletHistory,
  getCampaigns,
  deleteCampaign,
  activateCampaign,
  deactivateCampaign,
  getAdvertiserReport,
  getAddresses,
  getWalletHealth,
  getAdtechFeatureFlag,
  getCPCRecommendation,
  getSegment,
  getAdsAsset,
  getLatestRating,
  saveRating,
  getCampaignStatusGroup,
  getCampaignStats,
  createCampaignAudienceInsights,
  submitAcceptTermAndCondition,
  getPostpaidUsage,
  submitPostpaidBillingAccount,
  getAdCredit,
  getAdCreditHistory,
  submitActivatePostpaid,
  submitDeactivatePostpaid,
  getPostpaidInvoices,
  getPostpaidInvoice,
  getInvoiceLink,
  submitPostpaidPayment,
  syncPostpaidPayment,
  getPostpaidInvoiceStats,
  getAdsCreditHealth,
  getActivityLogs,
  getActivityEnums,
  getConversionOrders,
  getAudienceInsightsGroup,
  getOrderStats,
}
